import { css } from '@emotion/react';

export const dialogOverlayCx = css`
  z-index: var(--z-index-dialog);

  position: fixed;
  transform: translateX(-50%);
  top: 0;
  left: 50%;

  width: 100%;
  max-width: 100%;
  height: 100vh;
  height: 100dvh;

  background-color: var(--colors-overlay-70);
`;

export const dialogCx = css`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;

  display: flex;
  width: fit-content;
  max-width: inherit;
  min-width: 20.5rem;
  max-height: calc(100vh - 100px);
  overflow-y: auto;

  padding: 1.5rem 1rem;

  border-radius: var(--corner-lg);

  background-color: var(--colors-neutrals-10);

  &[data-fullscreen='true'] {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    border-radius: unset;
  }
`;
